<swiper-container slides-per-view="1" [loop]="false" class="limit-width-on-desktop" style="height: 100%;" #slides (swiperreachend)="sliderAtEnd()" (swiperslidechange)="slideDidChange($event)" autoplay="false">
  <swiper-slide>
    <video #stepOne [ngClass]="{'staticImage': this.sharedConfig.appClientDetail.static_landing, 'originalWithVideo': !this.sharedConfig.appClientDetail.static_landing}" poster="assets/images/posters/stepOnePoster.png" [muted]="true" autoplay muted defaultMuted playsinline (ended)="onEnded()">
      <source [src]="sharedConfig.appClientDetail.landing_videos.step_one_video_url" type="video/mp4" />
    </video>
  </swiper-slide>

  <swiper-slide>
    <video #stepTwo [ngClass]="{'staticImage': this.sharedConfig.appClientDetail.static_landing, 'originalWithVideo': !this.sharedConfig.appClientDetail.static_landing}" poster="assets/images/posters/stepTwoPoster.png" [muted]="true" preload="auto" muted defaultMuted playsinline>
      <source [src]="sharedConfig.appClientDetail.landing_videos.step_two_video_url" type="video/mp4" />
    </video>
  </swiper-slide>

  <swiper-slide>
    <video #stepThree [ngClass]="{'staticImage': this.sharedConfig.appClientDetail.static_landing, 'originalWithVideo': !this.sharedConfig.appClientDetail.static_landing}" poster="assets/images/posters/stepThreePoster.png" [muted]="true" preload="auto" muted defaultMuted playsinline>
      <source [src]="sharedConfig.appClientDetail.landing_videos.step_three_video_url" type="video/mp4" />
    </video>
  </swiper-slide>

  <swiper-slide>
    <video #stepFour [ngClass]="{'staticImage': this.sharedConfig.appClientDetail.static_landing, 'originalWithVideo': !this.sharedConfig.appClientDetail.static_landing}" poster="assets/images/posters/stepFourPoster.png" [muted]="true" preload="auto" muted defaultMuted playsinline>
      <source [src]="sharedConfig.appClientDetail.landing_videos.step_four_video_url" type="video/mp4" />
    </video>
  </swiper-slide>
</swiper-container>

<div *ngIf="lottieSplash" class="backdrop"></div>
<div *ngIf="lottieSplash" class="center-outer">
  <div class="center-inner">
    <div class="center-auto">
      <div class="loader-wrapper">
        <div role="status">
          <ion-img src="assets/logos/primary.svg"></ion-img>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="footer-wrapper">
  <div class="pagination p4">
    <ul>
      <a [ngClass]="{ 'is-active': getCurrentSliderIndex === 0 }">
        <li></li>
      </a>
      <a [ngClass]="{ 'is-active': getCurrentSliderIndex === 1 }">
        <li></li>
      </a>
      <a [ngClass]="{ 'is-active': getCurrentSliderIndex === 2 }">
        <li></li>
      </a>
      <a [ngClass]="{ 'is-active': getCurrentSliderIndex === 3 }">
        <li></li>
      </a>
    </ul>
  </div>
  <div class="buttons limit-width-on-desktop">
    <div class="signup-btn-div">
      <ion-button mode="ios" color="blue" class="primary-button" (click)="registerPage()"> Register </ion-button>
    </div>
    <div class="login-btn-div" (click)="loginPage()" routerDirection="forward">
      <ion-button mode="ios" class="secondary-button"> Log in </ion-button>
    </div>
  </div>
  <div class="mini-version">
    <p>{{sharedConfig.appVersion}}</p>
  </div>
</div>


<!-- TODO ALL OTHER POPUPS SHOULD BE REPLACED BY THIS GENERIC POPUP -->
<popup-dialog   id="landing.component" *ngIf="sharedConfig.popupDialogShow"></popup-dialog>
<div class="maintenance-popup-backdrop" *ngIf="sharedConfig.appSettings?.maintenance_mode && m_mode_popup"></div>
<div class="maintenance-popup limit-width-on-desktop" *ngIf="sharedConfig.appSettings?.maintenance_mode && m_mode_popup">
  <div class="lotti-maintenance">
    <lottie-player autoplay loop mode="normal" src="assets/lottie-animations/maintenance-mode.json"> </lottie-player>
  </div>
  <div class="heading">
    <h2 class="h2-bold">Maintenance Mode</h2>
  </div>
  <div class="message">
    <p>Hi there! We will be running a system upgrade tonight. While we do our magic, get some rest and visit us again
      tomorrow.
      We thank you for your patience and apologise for the inconvenience.</p>
  </div>
  <div class="buttons-wrapper">
    <ion-item mode="ios" lines="none">
      <ion-icon (click)="showBypass()" slot="end" name="enter-outline"></ion-icon>
    </ion-item>
  </div>
</div>

<popup-dialog id="forgot.password.component" *ngIf="sharedConfig.popupDialogShow"></popup-dialog>

<custom-popup *ngIf="showDecomNotice">
  <div class="text-center">
    <h2 class="h2-bold">Important Notice!</h2>
  </div>
  <div class="sub-header" style="padding: 10px 0;">
    <p>This platform will be discontinued on <b>20 April 2026.</b></p>
    <p>You will continue to have full access to broking support through our offices via email and telephone. For professional and efficient assistance, please contact us on <b>021 974 5200</b> or <a href="mailto:indwe@indwe.co.za">indwe@indwe.co.za</a>.</p>
    <p><b>Indwe | FSP 3425</b></p>
  </div>
  <div class="buttons-wrapper">
    <ion-button mode="ios" class="primary-button" (click)="continueFromDecomNotice()"> {{this.bottonWasClicked === 'register' ? 'Close' : 'Continue'}} </ion-button>
  </div>
</custom-popup>

<custom-popup *ngIf="maintenancePeriodNotification">
  <div class="text-center">
    <h2 class="h2-bold">Scheduled Maintenance</h2>
  </div>
  <div class="sub-header" style="padding: 10px 0;">
    <p>Kindly note, scheduled maintenance will be taking place from <b>{{this.sharedConfig.appSettings?.maintenance_period_start_date}}</b> until <b>{{this.sharedConfig.appSettings?.maintenance_period_end_date}}</b>.</p>
    <p>If you have a claim or need emergency assistance, please contact your provider directly:</p>
    <p><b>Brolink Assist: </b> <a href="tel:0102714244">010 271 4244</a></p>
    <p><b>King Price Assist: </b> <a href="tel:0860505050">0860 50 50 50</a></p>
    <p><b>Miway Assist: </b> <a href="tel:0860076764">0860 07 67 64</a></p>
    <p><b>Santam Direct Assist: </b> <a href="tel:0860505911">0860 505 911</a></p>
  </div>
  <div class="buttons-wrapper">
    <ion-button mode="ios" class="primary-button" (click)="closeMaintenancePeriodNotification()"> Ok </ion-button>
  </div>
</custom-popup>